module.exports = __webpack_public_path__ + "img/tarj2-2.3bb0c373.svg";